import { MetricUId } from "../../Metrics/constants"
import getChartConfigTemplate from "../Templates/StackedBarChart/utils";
import { mergeProps } from "../../../generic/Utils/mergeProps";

const metricColorMap = {
  [MetricUId.ALL_CONNECTED_USERS_ONETIME_WITH_ROLES]: "#0969DA",
  [MetricUId.NEVER_CONNECTED_USERS_ONETIME_WITH_ROLES]: "#FA5F5F"
}

const getChartConfig = function(props = {}) {
  const mergedProps = mergeProps(props, {
    seriesMetricsUids: [MetricUId.ALL_CONNECTED_USERS_ONETIME_WITH_ROLES, MetricUId.NEVER_CONNECTED_USERS_ONETIME_WITH_ROLES],
    metricColorMap: metricColorMap
  });

  return getChartConfigTemplate(mergedProps);
};

export default getChartConfig;